import React, { useEffect, useState } from "react";
import { Modal } from "./Modal";
import { Button } from "./Button";
import { ACTIONS } from "../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Api } from "../Service/api";
import { ErrorToast, SuccessToast } from "./Toast";
import { getlocalStorage } from "../Service/api/configuration/localstorage";
import Buliding from "../assets/images/Buliding.png";
import Chapter from "../assets/images/Chapter.png";
import Exam from "../assets/images/Exam.png";
import clock from "../assets/images/clock.png";
import task from "../assets/images/task.png";
import AddImg from "../assets/images/AddImg.png";

import CustomInput from "./CustomInput";
import { Slider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { path } from "../Utils/ScreenPath";

const PrintModel = ({
  isModelOpen,
  setisModelOpen,
  handleModelClose,
  modelCall,
  setModelCall,
  headerPath,
  buttonText = "Preview & Download Exam Paper",
  editButtonText = "Edit Paper",
  isEdit = false,
}) => {
  // logo model
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = getlocalStorage("userData");
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
  const lastPaperId = useSelector((state) => state?.PaperId?.paperId);

  const [instituteModel, setInstituteModel] = useState(false);
  const [instituteData, setInstituteData] = useState([]);
  const [uplodedImage, setUplodedImage] = useState("");
  const [instituteLogo, setInstituteLogo] = useState("");
  const [waterMarkLogo, setWaterMarkLogo] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [checkedItems, setCheckedItems] = useState({
    addBorder: false,
    addFooterText: false,
    addLastMessage: false,
    examDate: false,
    waterMark: false,
    waterMark: false,
    pageNumber: false,
    dualPaperView: false,
  });
  const [selectedRadio, setSelectedRadio] = useState(0);
  const [selectedWaterRadio, setSelectedWaterRadio] = useState(0);
  const [printImg, setPrintImg] = useState("");
  const [printData, setPrintData] = useState({});
  const [sliderValue, setSliderValue] = useState(50);

  const checkboxOptions = [
    { id: "addLastMessage", label: "Add Last Message" },
    { id: "addFooterText", label: "Add Footer Text" },
    { id: "addBorder", label: "Add Border" },
    { id: "waterMark", label: "Water Mark" },
    { id: "examDate", label: "Exam Date" },
    { id: "pageNumber", label: "Add Page Number" },
    { id: "dualPaperView", label: "2 Column Paper" },
  ];
  const [checkBoxData, setCheckBoxData] = useState(checkboxOptions);

  useEffect(() => {
    const fetchSubjectCapability = async () => {
      // If no subject selected, hide the button
      if (!selectedData?.subject_id || !selectedData?.semester_id || !selectedData?.standard_id) {
        setCheckBoxData(prev => prev.filter(item => item.id !== 'dualPaperView'));
        return;
      }

      try {
        const semester = selectedData?.semester_id || selectedData?.semester;
        const standard = selectedData?.standard_id || selectedData?.standard;
        const medium = selectedData?.medium_id || selectedData?.medium;

        // Fetch subject list from database
        const payload = `?semester=${semester}&standard=${standard}&semister=${semester}&medium_id=${medium}&isManual=true&isLearn=false&limit=1000&Offset=1`;
        const { data } = await Api.GetSubject(payload);
        const res = JSON.parse(data);

        if (res?.status === 200) {
          // Find the current subject in the list
          const subject = res?.data?.find(item => item.id == selectedData?.subject_id || item.id == selectedData?.subject);

          // Get the dualPaperView value from database (0 or 1)
          const dualPaperViewValue = subject?.dualPaperView;

          // Strictly check: Only show if value is exactly 1
          if (dualPaperViewValue === 1 || dualPaperViewValue === "1") {
            // Database says: dualPaperView = 1 → SHOW the checkbox
            setCheckBoxData(prev => {
              if (!prev.some(item => item.id === 'dualPaperView')) {
                return [...prev, { id: "dualPaperView", label: "2 Column Paper" }];
              }
              return prev;
            });

            setCheckedItems((prev) => {
              // Explicit check for OFF state only
              const isExplicitlyOff =
                selectedData?.dualPaperView === 0 ||
                selectedData?.dualPaperView === false ||
                selectedData?.isAccessDualPaper === 0;

              if (isExplicitlyOff) {
                return { ...prev, dualPaperView: false };
              }

              // If not explicitly OFF, it defaults to ON (since database says it's allowed)
              return { ...prev, dualPaperView: true };
            });
          } else {
            // Database says: dualPaperView = 0 (or undefined/null) → HIDE the checkbox
            setCheckBoxData(prev => prev.filter(item => item.id !== 'dualPaperView'));
            setCheckedItems((prev) => ({ ...prev, dualPaperView: false }));
          }
        }
      } catch (error) {
        console.error("Error fetching subject capability:", error);
        // On error, hide to be safe
        setCheckBoxData(prev => prev.filter(item => item.id !== 'dualPaperView'));
      }
    };

    fetchSubjectCapability();
  }, [selectedData?.subject_id, selectedData?.semester_id, selectedData?.standard_id]);

  const radioOptions = [
    { id: 0, label: "Exam Paper" },
    { id: 1, label: "Exam Paper & Solution with Answers" },
    { id: 2, label: "Material" },
    { id: 3, label: "Worksheet" },
  ];

  const waterMarkOptions = [
    { id: 0, label: "Text" },
    { id: 1, label: "Image" },
  ];

  const handleCheckboxChange = (id) => {

    if (id == "waterMark") {
      handleModelDataChange("", "waterMarkUrl")
    }
    if (id == "examDate") {
      handleModelDataChange("", "exam_date")
    }
    if (id == "addLastMessage") {
      handleModelDataChange("", "last_message")
    }
    if (id == "addFooterText") {
      handleModelDataChange("", "footerText")
    }

    setCheckedItems((prev) => ({ ...prev, [id]: !prev[id] }));

  };

  const handleRadioChange = (id) => {
    setSelectedRadio(id);

    if (id == 0 || id == 1) {
      if (!checkBoxData.some((option) => option.id === "examDate")) {
        setCheckBoxData((prev) => [
          ...prev,
          { id: "examDate", label: "Exam Date" },
        ]);
      }
    }
    if (id == 2 || id == 3) {
      const index = checkBoxData.findIndex(
        (option) => option.id === "examDate"
      );
      if (index !== -1) {
        setCheckBoxData((prev) => prev.filter((_, i) => i !== index));
      }
    }
  };

  const handleWaterRadioChange = (id) => {
    setSelectedWaterRadio(id);
  };

  const handlelogoModelClose = () => {
    setInstituteModel(!instituteModel);
  };

  const handleRemoveImage = (item) => {
    _RemoveImage(item);
  };

  const handleSliderChange = (event, newValue) => {
    setSliderValue(newValue);
  };
  const handleRemoveSeletedImage = (value) => {
    if (value == "logo") {
      setInstituteLogo("");
      setPrintData({ ...printData, institute_logo: "" });
    }
    if (value == "watermark") {
      setWaterMarkLogo("");
      setPrintData({ ...printData, waterMarkUrl: "" });
    }
  };
  const handleImageAdd = (item) => {
    if (printImg == "logo") {
      setInstituteLogo(item?.photo);
      setPrintData({ ...printData, institute_logo: item?.photo });
    }
    if (printImg == "watermark") {
      setWaterMarkLogo(item?.photo);
      setPrintData({ ...printData, waterMarkUrl: item?.photo });
    }
    setInstituteModel(!instituteModel);
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    setSelectedFile(file);
    _ImageUpload(file);
  };

  const handleFileSelectModel = (e) => {
    setInstituteModel(!instituteModel);
    _getInstituteList();
    setPrintImg("logo");
  };

  const handleAddImg = () => {
    setInstituteModel(!instituteModel);
    _getInstituteList();
    setPrintImg("watermark");
  };

  const handleModelDataChange = (value, name) => {
    setPrintData({ ...printData, [name]: value });
  };

  const handleModelapply = () => {
    dispatch(
      ACTIONS.getSelectedData({
        ...selectedData,
        school_name: printData?.school_name || selectedData?.school_name,
        template_name: "",
        exam_name: printData?.exam_name ?? selectedData?.exam_name ?? "",
        chapter_name: printData?.chapter_name || "",
        exam_time: printData?.exam_time || "",
        exam_marks: printData?.exam_marks || "",
        exam_date:
          (selectedRadio == 0 || selectedRadio == 1) &&
            checkBoxData?.some((option) => option?.id === "examDate") &&
            printData?.exam_date
            ? printData?.exam_date
            : "",
        waterMarkUrl: checkedItems?.waterMark
          ? selectedWaterRadio == 0
            ? printData?.waterMarkUrl
            : waterMarkLogo
          : "",
        institute_logo: instituteLogo || "",
        footerText: checkedItems?.addFooterText ? printData?.footerText : "",
        isborder: checkedItems?.addBorder,
        paperType: selectedRadio,
        watermark_size: sliderValue,
        watermark_opacity: 50,
        last_message: checkedItems?.addLastMessage ? printData?.last_message : "",
        last_message: checkedItems?.addLastMessage ? printData?.last_message : "",
        isPageNumber: checkedItems?.pageNumber,
        dualPaperView: (checkedItems?.dualPaperView && checkBoxData.some(item => item.id === 'dualPaperView')) ? 1 : 0,
      })
    );
    if (lastPaperId) {
      localStorage.setItem(`dualPaperView_${lastPaperId}`, checkedItems?.dualPaperView);
    }
    dispatch(ACTIONS.GetPaperId(""));
    dispatch(ACTIONS.getHeaderPath(headerPath));
    navigate(path?.PdfPreview);
    setisModelOpen(!isModelOpen);
  };

  const _getInstituteList = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      const { data } = await Api.GetInstituteimages();
      const res = JSON.parse(data);
      if (res?.status === 200) {
        if (res?.data.length > 0) {
          setInstituteData(res?.data);
        }
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _ImageUpload = async (file) => {
    let img = new FormData();
    img?.append("image", file);

    dispatch(ACTIONS.startLoading());
    try {
      const res = await Api.ImageUpload(img);
      SuccessToast(res?.message);
      setUplodedImage(res?.data);
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _RemoveImage = async (item) => {
    dispatch(ACTIONS.startLoading());
    try {
      const { data } = await Api.RemoveImage(item?.id);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast(res?.message);
        setUplodedImage("");
        _getInstituteList();
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _CreateImage = async (image) => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        user_id: userData?.user_id,
        photo: image,
      };
      const { data } = await Api.Createinstituteimages(JSON.stringify(body));
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast(res?.message);
        _getInstituteList();
        setUplodedImage("");
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _getPaperHistory = async (total) => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        limit: 1,
        offset: 1,
      };
      const { data } = await Api.paperHistory(body);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        setPrintData({
          ...printData,
          exam_marks: total,
          school_name: res?.data[0]?.school_name,
          exam_name: res?.data[0]?.exam_name,
          chapter_name: res?.data[0]?.chapter_name,
          exam_time: res?.data[0]?.exam_time,
          exam_date: res?.data[0]?.exam_date,
          last_message: res?.data[0]?.last_message,
          footerText: res?.data[0]?.footerText,
          waterMarkUrl: res?.data[0]?.waterMarkUrl?.includes("https://")
            ? ""
            : res?.data[0]?.waterMarkUrl,
        });
        setCheckedItems((prev) => ({
          ...prev,
          addBorder: res?.data[0]?.isborder,
          addFooterText: res?.data[0]?.footerText ? true : false,
          addLastMessage: res?.data[0]?.last_message ? true : false,
          pageNumber: true,
          examDate: res?.data[0]?.examDate ? true : false,
          pageNumber: true,
          examDate: res?.data[0]?.examDate ? true : false,
          waterMark: res?.data[0]?.waterMarkUrl ? false : true,
          dualPaperView: (checkBoxData.some(item => item.id === 'dualPaperView')) ? true : ((res?.data[0]?.dualPaperView ?? res?.data[0]?.isAccessDualPaper) ? true : false),
        }))
        setSelectedWaterRadio(res?.data[0]?.waterMarkUrl?.includes("https://") ? 1 : 0);
        setSelectedRadio(res?.data[0]?.paperType ?? 0);
        setInstituteLogo(res?.data[0]?.institute_logo);
        setSliderValue(res?.data[0]?.watermark_size);
        setSelectedRadio(res?.data[0]?.paperType ?? 0);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };



  useEffect(() => {
    if (uplodedImage) {
      _CreateImage(uplodedImage);
    }
  }, [uplodedImage]);

  useEffect(() => {
    if (modelCall) {
      let total = 0;
      selectedData?.sections_info?.forEach((section) => {
        section.divisions.forEach((division) => {
          total += parseInt(division.marks, 10); // Convert string marks to number
        });
      });

      if (isEdit == "false") {
        _getPaperHistory(total);
      } else {
        setPrintData({
          ...printData,
          exam_marks: total,
          school_name: selectedData?.school_name,
          exam_name: selectedData?.exam_name,
          chapter_name: selectedData?.chapter_name,
          exam_time: selectedData?.exam_time,
          exam_date: selectedData?.exam_date,
          last_message: selectedData?.last_message,
          footerText: selectedData?.footerText,
          waterMarkUrl: selectedData?.waterMarkUrl?.includes("https://")
            ? ""
            : selectedData?.waterMarkUrl,
        });
        setCheckedItems({
          ...checkedItems,
          addBorder: selectedData?.isborder ? true : false,
          addFooterText: selectedData?.footerText ? true : false,
          addLastMessage: selectedData?.last_message ? true : false,
          examDate: selectedData?.exam_date ? true : false,
          waterMark: selectedData?.waterMarkUrl ? true : false,
          waterMark: selectedData?.waterMarkUrl ? true : false,
          pageNumber: false,
          dualPaperView: (selectedData?.dualPaperView === 0 || selectedData?.dualPaperView === false) ? false : true,
        });
        setSelectedWaterRadio(
          selectedData?.waterMarkUrl?.includes("https://") ? 1 : 0
        );
        setSelectedRadio(selectedData?.paperType ?? 0);
        setWaterMarkLogo(
          selectedData?.waterMarkUrl?.includes("https://")
            ? selectedData?.waterMarkUrl
            : ""
        );
        setInstituteLogo(selectedData?.institute_logo);
      }

      setModelCall(false);
    }
  }, [modelCall]);

  return (
    <div>
      <Modal
        title="Print Settings"
        buttonText={buttonText}
        editButtonText={editButtonText}
        width="max-w-2xl"
        disabled={printData?.school_name ? false : true}
        modalOpen={isModelOpen}
        onApply={handleModelapply}
        onEditPaper={handleModelapply}
        onClose={handleModelClose}
      >
        <div
          style={{ margin: "10px 0px" }}
          className="max-h-[60vh] overflow-y-auto"
        >
          <div
            style={{
              display: "flex",
              border: "1px solid #e5e7eb",
              padding: "10px",
              marginBottom: "10px",
              borderRadius: "10px",
              gap: "10px",
              alignItems: "center",
            }}
            onClick={handleFileSelectModel}
          >
            {instituteLogo ? (
              <div className="relative inline-block">
                <img
                  src={instituteLogo}
                  alt="logo"
                  className="max-h-28  rounded-md border-2 border-gray-300"
                />
                <button
                  onClick={() => handleRemoveSeletedImage("logo")} // Your remove or close handler function
                  className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 text-gray-600 rounded-full p-1 hover:bg-gray-200"
                  style={{ width: "24px", height: "24px", lineHeight: "0" }}
                >
                  &#10005; {/* This is the "x" symbol for close */}
                </button>
              </div>
            ) : (
              <div className="relative inline-block">
                <img src={AddImg} alt="logo" className="max-h-28" />
              </div>
            )}

            <p>Institute Logo Title (Size:260*40 mm)</p>
          </div>

          <div className="flex gap-4 flex-wrap py-1 justify-between ">
            <div className="md:basis-[48%] basis-full">
              <CustomInput
                type="text"
                label="School Name"
                required
                placeholder="Enter Name"
                value={printData?.school_name}
                onChange={(value) =>
                  handleModelDataChange(value, "school_name")
                }
                icon={
                  <img src={Buliding} alt="Building Icon" className="w-5 h-5" />
                }
              />
            </div>
            <div className="md:basis-[48%] basis-full">
              <CustomInput
                type="text"
                label="Exam Name"
                placeholder="Enter Name"
                value={printData?.exam_name}
                onChange={(value) => handleModelDataChange(value, "exam_name")}
                icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
              />
            </div>
            <div className="md:basis-[48%] basis-full">
              <CustomInput
                type="text"
                label="Chapter Name"
                placeholder="Enter chapter"
                value={printData?.chapter_name}
                onChange={(value) =>
                  handleModelDataChange(value, "chapter_name")
                }
                icon={
                  <img src={Chapter} alt="Chapter Icon" className="w-5 h-5" />
                }
              />
            </div>
            <div className="md:basis-[48%] basis-full">
              <CustomInput
                type="text"
                label="Exam Time"
                placeholder="Enter Time"
                value={printData?.exam_time}
                onChange={(value) => handleModelDataChange(value, "exam_time")}
                icon={<img src={clock} alt="Clock Icon" className="w-5 h-5" />}
              />
            </div>
            <div className="md:basis-[48%] basis-full">
              <CustomInput
                type="Number"
                label="Exam Marks"
                placeholder="Enter Marks"
                value={printData?.exam_marks}
                onChange={(value) => handleModelDataChange(value, "exam_marks")}
                icon={<img src={task} alt="task Icon" className="w-5 h-5" />}
              />
            </div>
            {checkedItems?.examDate &&
              (selectedRadio == 0 || selectedRadio == 1) && (
                <div className="md:basis-[48%] basis-full">
                  <CustomInput
                    type="date"
                    label="Date"
                    placeholder="Enter Date"
                    value={printData?.exam_date}
                    onChange={(value) =>
                      handleModelDataChange(value, "exam_date")
                    }
                    icon={
                      <img
                        src={Buliding}
                        alt="Building Icon"
                        className="w-5 h-5"
                      />
                    }
                  />
                </div>
              )}
            {checkedItems?.addLastMessage && (
              <div className="md:basis-[48%] basis-full">
                <CustomInput
                  type="text"
                  label="Add Last Message"
                  placeholder="Enter Message"
                  value={printData?.last_message}
                  onChange={(value) =>
                    handleModelDataChange(value, "last_message")
                  }
                  icon={<img src={Exam} alt="Exam Icon" className="w-5 h-5" />}
                />
              </div>
            )}
            {checkedItems?.addFooterText && (
              <div className="md:basis-[48%] basis-full">
                <CustomInput
                  type="text"
                  label="Footer Text"
                  placeholder="Enter chapter"
                  value={printData?.footerText}
                  onChange={(value) =>
                    handleModelDataChange(value, "footerText")
                  }
                  icon={<img src={task} alt="task Icon" className="w-5 h-5" />}
                />
              </div>
            )}
          </div>

          <div className="py-3 rounded-lg max-w-2xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6">
              {checkBoxData.map((option) => (
                <label
                  key={option.id}
                  className="flex items-center space-x-3 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    id={option.id}
                    checked={checkedItems[option.id] || false}
                    onChange={() => handleCheckboxChange(option.id)}
                    className="form-checkbox h-5 w-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                  />
                  <span className="text-gray-700 text-sm ">{option.label}</span>
                </label>
              ))}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              {checkedItems?.waterMark && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {waterMarkOptions.map((option) => (
                    <label
                      key={option.id}
                      className="flex items-center space-x-3 cursor-pointer"
                    >
                      <input
                        type="radio"
                        id={option.id}
                        name="water Mark"
                        value={option.id}
                        checked={selectedWaterRadio === option.id}
                        onChange={() => handleWaterRadioChange(option.id)}
                        className="form-radio h-5 w-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                      />
                      <span className="text-gray-700 text-sm">
                        {option.label}
                      </span>
                    </label>
                  ))}
                </div>
              )}
              {checkedItems?.waterMark &&
                (selectedWaterRadio == 0 ? (
                  <div className="md:basis-[48%] basis-full">
                    <CustomInput
                      type="text"
                      label="Watermark Text"
                      placeholder="Enter Message"
                      value={printData?.waterMarkUrl}
                      onChange={(value) =>
                        handleModelDataChange(value, "waterMarkUrl")
                      }
                      icon={
                        <img
                          src={Chapter}
                          alt="Exam Icon"
                          className="w-5 h-5"
                        />
                      }
                    />
                  </div>
                ) : waterMarkLogo ? (
                  <>
                    <div style={{ width: 300, padding: "0 10px" }}>
                      <span className="text-sm font-medium text-gray-700">
                        Watermark Size
                      </span>
                      <Slider
                        defaultValue={sliderValue}
                        aria-label="Default"
                        valueLabelDisplay="auto"
                        onChange={handleSliderChange}
                      />
                    </div>
                    <div className="relative inline-block w-[fit-content]">
                      <img
                        src={waterMarkLogo}
                        alt="User profile"
                        className="max-h-28  rounded-md border-2 border-gray-300"
                      />
                      <button
                        onClick={() => handleRemoveSeletedImage("watermark")} // Your remove or close handler function
                        className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 text-gray-600 rounded-full p-1 hover:bg-gray-200"
                        style={{
                          width: "24px",
                          height: "24px",
                          lineHeight: "0",
                        }}
                      >
                        &#10005; {/* This is the "x" symbol for close */}
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="relative inline-block">
                    <img
                      src={AddImg}
                      alt="User profile"
                      className="w-[50px]"
                      onClick={handleAddImg}
                    />
                  </div>
                ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {radioOptions.map((option) => (
                <label
                  key={option.id}
                  className="flex items-center space-x-3 cursor-pointer"
                >
                  <input
                    type="radio"
                    id={option.id}
                    name="examType"
                    value={option.id}
                    checked={selectedRadio === option.id}
                    onChange={() => handleRadioChange(option.id)}
                    className="form-radio h-5 w-5 text-blue-600 border-gray-300 focus:ring-blue-500"
                  />
                  <span className="text-gray-700 text-sm">{option.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title="institute logo"
        width="max-w-2xl"
        modalOpen={instituteModel}
        onClose={handlelogoModelClose}
      >
        <div style={{ margin: "15px 0px" }}>
          <div
            style={{
              display: "flex",
              gap: "16px",
              flexWrap: "wrap",
              marginBottom: "20px",
            }}
          >
            {instituteData?.map((item, index) => (
              <div className="relative inline-block">
                <img
                  src={item?.photo}
                  alt="User profile"
                  className="max-w-28 max-h-28 rounded-md border-2 border-gray-300"
                  onClick={() => handleImageAdd(item)}
                />

                {/* Cross icon */}
                <button
                  onClick={() => handleRemoveImage(item)} // Your remove or close handler function
                  className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 text-gray-600 rounded-full p-1 hover:bg-gray-200"
                  style={{ width: "24px", height: "24px", lineHeight: "0" }}
                >
                  &#10005; {/* This is the "x" symbol for close */}
                </button>
              </div>
            ))}
          </div>

          <input
            id="fileInput"
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />

          <Button
            onClick={() => document.getElementById("fileInput").click()}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            label="Upload Image"
          >
            Upload Image
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default PrintModel;
